import { render, staticRenderFns } from "./dejhgl.vue?vue&type=template&id=1887bf4b&scoped=true"
import script from "./dejhgl.vue?vue&type=script&lang=js"
export * from "./dejhgl.vue?vue&type=script&lang=js"
import style0 from "./dejhgl.vue?vue&type=style&index=0&id=1887bf4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887bf4b",
  null
  
)

export default component.exports